export default __webpack_public_path__ + "static/media/bronze-package.c3fda2eb.png";